import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import React, { useState } from 'react'
import Grid from '@mui/material/Grid'
import { Step3Props } from '../types'
import { Controller } from 'react-hook-form'
import Button from '@mui/material/Button'

import { Alert, CircularProgress, Divider, FormLabel, Typography, useMediaQuery, useTheme } from '@mui/material'
import HelperModal from '../../../hoc/HelperModal'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { BrowserView, MobileView } from 'react-device-detect'
import MobileDatePicker from '@mui/lab/MobileDatePicker'
import { cs } from 'date-fns/locale'
import useStyles from '../styles/Step3.styles'
import FormItem from '../../../hoc/FormItem'
import { useGtmPageView } from '../../hooks'
import TagManager from 'react-gtm-module'
import { UserInformModal } from '../components/UserInformModal'

const Step3View: React.FC<Step3Props> = ({
    form,
    onStepBack,
    options,
    conditions,
    isUpdating,
    activationObject,
    flatKeysInformProps,
}) => {
    const classes = useStyles()
    const { control, formState, handleSubmit } = form.form
    const theme = useTheme()
    const isPortableAndDesktop = useMediaQuery(theme.breakpoints.up('sm'))
    const handoverAll = ['Na pozemek i od objektu', 'Od vchodu i bytu', 'Vnitřní i vnější prostory']
    const handoverBuilding = ['Pouze na pozemek', 'Od vchodu', 'Vnější prostory']
    const stopSubmitCondition =
        activationObject?.objectType === 'Flat' && conditions.enableCustomerPresence && !flatKeysInformProps.isUserInformed
    const [informModalOpen, setInformModalOpen] = useState(false)

    useGtmPageView({ pageName: 'Step3', synonym: activationObject?.synonym })

    return (
        <form onSubmit={handleSubmit(form.onSubmit)} method='post' autoComplete='off'>
            <Box p={2} maxWidth={1050}>
                <Box p={1} paddingBottom={{ sm: 0 }} textAlign={'left'}>
                    <Typography fontSize={{ xs: '1.2rem', sm: '1.973rem' }} variant='h4'>
                        {' '}
                        KONTROLA OBJEKTU
                    </Typography>
                </Box>
                <Box p={1} paddingTop={0} fontSize={'0.875rem'} textAlign={'left'}>
                    Na základě vyplněných dat bude probíhat kontrola objektu
                </Box>
                <Divider></Divider>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid container item xs={11}>
                        <Grid item xs={12} md={3.5} display={'inline'}>
                            <FormItem>
                                <FormLabel className={classes.formLabelBlock}>Pes na objektu </FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            <FormItem>
                                <Controller
                                    name={'locationDog'}
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row={isPortableAndDesktop}>
                                            <FormControlLabel
                                                value='FreeOutside'
                                                control={<Radio color='primary' />}
                                                label='Pes volně na pozemku'
                                            />
                                            <FormControlLabel
                                                value='FreeInside'
                                                control={<Radio color='primary' />}
                                                label='Pes volně v budově'
                                            />
                                            <FormControlLabel
                                                value='NotFree'
                                                control={<Radio color='primary' />}
                                                label='Pes vždy zajištěn'
                                            />
                                            <FormControlLabel
                                                value='NotPresent'
                                                control={<Radio color='primary' />}
                                                label='Není'
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                    <Grid item xs={1} display={'inline'}>
                        <FormItem>
                            <HelperModal textKey='OBJECT_DOG' />
                        </FormItem>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid container item xs={11}>
                        <Grid item xs={12} md={3.5} display={'inline'}>
                            <FormItem>
                                <FormLabel className={classes.formLabelBlock}>Přístupové prostředky</FormLabel>
                                <FormLabel className={classes.formSubLabelBlock}>(např.: klíče, karty, ovladače, čipy)</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            <FormItem>
                                <Controller
                                    name={'handoverKeys'}
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row={isPortableAndDesktop}>
                                            <FormControlLabel
                                                disabled={conditions.dogUnleashed || conditions.dogUnleashedInBuilding}
                                                value='LandAndObject'
                                                control={<Radio color='primary' />}
                                                label={
                                                    activationObject?.objectType === 'FamilyHouse'
                                                        ? handoverAll[0]
                                                        : activationObject?.objectType === 'Flat'
                                                        ? handoverAll[1]
                                                        : handoverAll[2]
                                                }
                                            />

                                            <FormControlLabel
                                                disabled={conditions.dogUnleashed}
                                                value='OnlyLand'
                                                control={<Radio color='primary' />}
                                                label={
                                                    activationObject?.objectType === 'FamilyHouse'
                                                        ? handoverBuilding[0]
                                                        : activationObject?.objectType === 'Flat'
                                                        ? handoverBuilding[1]
                                                        : handoverBuilding[2]
                                                }
                                            />

                                            <FormControlLabel
                                                value='NotHandoverKeys'
                                                control={<Radio color='primary' />}
                                                label='Bez předání'
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                    <Grid item xs={1} display={'inline'}>
                        <FormItem>
                            <HelperModal textKey='TERM_KEY' />
                        </FormItem>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid container item xs={11}>
                        <Grid item xs={12} md={3.5} display={'inline'}>
                            <FormItem>
                                <FormLabel className={classes.formLabelBlock}>Umístění kontrolních čipů</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            <FormItem>
                                <Controller
                                    name={'setControlChips'}
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row>
                                            <FormControlLabel value={true} control={<Radio color='primary' />} label='Ano' />
                                            <FormControlLabel value={false} control={<Radio color='primary' />} label='Ne' />
                                        </RadioGroup>
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <FormItem>
                            <HelperModal textKey='INSTAL_CHIPS' />
                        </FormItem>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 1, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }} mb={2}>
                    <Grid item>
                        <Alert severity='info'>
                            <Typography>
                                Kontrola objektu probíhá z míst legálně dostupných zásahové jednotce. Upozorňujeme, že při
                                kontrole objektu nejsou pracovníci zásahové jednotky oprávněni bez příslušných přístupových
                                prostředků (např. klíče, karty, ovladače, čipy, kódy pro odemčení a odkódování) překonávat
                                jakékoliv překážky (jako např. ploty, vrata apod.), zároveň nevstupují do prostor, kde je volně
                                pohybující se zvíře.
                            </Typography>
                        </Alert>
                    </Grid>
                </Grid>

                <Box p={1} paddingTop={2} fontSize={'0.875rem'} textAlign={'left'}>
                    <Typography variant='h6'>Prohlídka objektu zásahovou jednotkou před zahájením poskytování služeb</Typography>
                </Box>
                <Divider></Divider>

                <Grid className={classes.longLabelText} container rowSpacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <FormItem marginTop={{ xs: '10px', md: 0 }}>
                            <FormLabel className={classes.formLabelBlock}>Přítomnost zákazníka u prohlídky</FormLabel>
                        </FormItem>
                    </Grid>

                    <Grid item xs={12} sm={6} md={9}>
                        <FormItem paddingLeft={{ md: 2 }}>
                            <Controller
                                name={'customerPresence'}
                                control={control}
                                render={({ field }) => (
                                    <RadioGroup {...field} row>
                                        <FormControlLabel
                                            value={true}
                                            disabled={!conditions.enableCustomerPresence}
                                            control={<Radio color='primary' />}
                                            label='Ano'
                                        />
                                        <FormControlLabel
                                            value={false}
                                            disabled={!conditions.enableCustomerPresence}
                                            control={<Radio color='primary' />}
                                            label='Ne'
                                        />
                                    </RadioGroup>
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>
                {!conditions.disableChippingDate && (
                    <Grid container>
                        <Grid container rowSpacing={1} item xs={11}>
                            <Grid item xs={12} md={3.5} display={'inline'}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Termín prohlídky</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={6} md={4.25}>
                                <FormItem>
                                    <Controller
                                        name={'handoverDate'}
                                        control={control}
                                        render={({ field }) => (
                                            <LocalizationProvider locale={cs} dateAdapter={AdapterDateFns}>
                                                <BrowserView>
                                                    <DesktopDatePicker
                                                        {...field}
                                                        label=''
                                                        value={field.value || ''}
                                                        disablePast
                                                        inputFormat='dd.MM.yyyy'
                                                        shouldDisableDate={conditions.isDayDisabled}
                                                        minDate={conditions.handoverMinDate}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                inputProps={{
                                                                    ...params.inputProps,
                                                                    placeholder: 'dd/mm/rrrr',
                                                                }}
                                                                sx={{ input: { '::placeholder': { opacity: '0.8' } } }}
                                                                error={formState.errors.handoverDate !== undefined}
                                                                helperText={formState.errors.handoverDate?.message}
                                                                fullWidth
                                                                onKeyDown={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </BrowserView>
                                                <MobileView>
                                                    <MobileDatePicker
                                                        {...field}
                                                        disablePast
                                                        label=''
                                                        inputFormat='dd.MM.yyyy'
                                                        shouldDisableDate={conditions.isDayDisabled}
                                                        minDate={conditions.handoverMinDate}
                                                        disableCloseOnSelect={isPortableAndDesktop}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                inputProps={{
                                                                    ...params.inputProps,
                                                                    placeholder: 'dd/mm/rrrr',
                                                                }}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                sx={{ input: { '::placeholder': { opacity: '0.8' } } }}
                                                                error={formState.errors.handoverDate !== undefined}
                                                                helperText={formState.errors.handoverDate?.message}
                                                                fullWidth
                                                                onKeyDown={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </MobileView>
                                            </LocalizationProvider>
                                        )}
                                    />
                                </FormItem>
                            </Grid>
                            <Grid item xs={6} md={4.25} paddingLeft={1}>
                                {options.handoverTimes && (
                                    <FormItem>
                                        <Controller
                                            name={'handoverHour'}
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    value={field.value || ''}
                                                    select
                                                    fullWidth
                                                    error={formState.errors.handoverHour !== undefined}
                                                    helperText={formState.errors.handoverHour?.message}
                                                >
                                                    {options.handoverTimes &&
                                                        options.handoverTimes.map((option, index) => (
                                                            <MenuItem key={index} value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                </TextField>
                                            )}
                                        />
                                    </FormItem>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={1}>
                            <FormItem paddingLeft={{ md: 2 }}>
                                <HelperModal textKey='APPROACH_DATE' />
                            </FormItem>
                        </Grid>
                    </Grid>
                )}

                <Box paddingTop={2} className={classes.flex}>
                    <Button variant='outlined' onClick={onStepBack}>
                        &#60; Zpět
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        type={stopSubmitCondition ? 'button' : 'submit'}
                        disabled={isUpdating}
                        startIcon={isUpdating && <CircularProgress size={20} />}
                        onClick={() => {
                            if (stopSubmitCondition) {
                                setInformModalOpen(true)
                                return
                            }
                            TagManager.dataLayer({
                                dataLayer: {
                                    event: 'clickNext',
                                },
                            })
                        }}
                    >
                        Pokračovat &#62;
                    </Button>
                </Box>
                <UserInformModal
                    modalOpen={informModalOpen}
                    setModalOpen={setInformModalOpen}
                    informFunction={flatKeysInformProps.handleUserInform}
                    textKey={'USER_KEYS_INFORM'}
                />
            </Box>
        </form>
    )
}

export default Step3View
